export default __webpack_public_path__ + "static/media/AfterOn.09de5643.svg";